<div class="login-container">
  <div class="card login-card">
    <div class="logo">
      <img src="assets/logo_domino.png" alt="Domino" />
      <h1>Domino</h1>
    </div>
    <p>Redirection vers la mire d'authentification Teréga en cours...</p>
  </div>
</div>
